import React, { memo, useState } from "react";
import { Stack } from "investira.react.components";
import CenariosDetalhes from "./CenariosDetalhes";
import DetalhesDialog from "./DetalhesDialog";
import CorrelacaoDialog from "./CorrelacaoDialog";

const Cenarios = memo((props) => {
  const { data } = props;
  const [ativos, setAtivos] = useState({});
  const [infos, setInfos] = useState({});
  const [correlacoes, setCorrelacoes] = useState(null);

  const xBenchmarks = data.response?.detalhe?.benchmarks;
  const xCorrelacoes = data.response?.detalhe?.correlacoes;

  return (
    <Stack spacing={4}>
      <CenariosDetalhes
        data={data}
        onSetAtivos={setAtivos}
        onSetInfos={setInfos}
        onSetCorrelacoes={setCorrelacoes}
      />
      <DetalhesDialog
        ativos={ativos}
        correlacoes={xCorrelacoes}
        benchmarks={xBenchmarks}
        infos={infos}
        onSetAtivos={setAtivos}
      />
      {/* <CorrelacaoDialog
        ativos={ativos}
        infos={infos}
        benchmarks={xBenchmarks}
        correlacoes={correlacoes}
        onSetAtivos={setAtivos}
        onSetCorrelacoes={setCorrelacoes}
      /> */}
    </Stack>
  );
});

Cenarios.displayName = "Cenarios";

export default Cenarios;
